import { createAction } from '@reduxjs/toolkit';

export const setItemGroup = createAction('SET_ITEM_GROUP');
export const setItems = createAction('SET_ITEMS');
export const resetItemGroup = createAction('resetItemGroup');
export const resetItems = createAction('resetItems');
export const outGoingPaymentAction = createAction('OutGoingPayment');
export const CompanyListAction = createAction('CompanyList');
export const BranchListAction = createAction('BranchList');
export const CustomerCreationAction = createAction('CustomerCreationData');
export const UpdateCustomerDataAction = createAction('UPDATE_CUSTOMER_DATA');
export const resetCustomerDetails = createAction('RESET_CUSTOMER_DETAILS');
export const CRMData = createAction('CRM_data');
export const CRMPostData = createAction('CRM_Postdata');
export const resetCrmData = createAction('Reset_CRM_Postdata');
export const ClickData = createAction('Click_Data');
export const OpprtunityBySlpCode = createAction('Opprtunity_BySlpCode');

